<template>
  <div class="horizontal-menu secondary">
    <ul class="list-unstyled nav">
      <li class="nav-item">
        <a
          href="javascript:void(0);"
          class="nav-link"
        >
          <span class="menu-title">Menu</span>
        </a>
        <ul class="sub-menu list-unstyled">
          <template v-for="item in menus">
            <app-menu-item
              :menu="item"
              :key="item.title"
            ></app-menu-item>
          </template>
        </ul>
      </li>

      <li class="nav-item"></li>

      <template v-if="menuSeleccionado">
        <li class="nav-item">
          <div class="nav-link no-arrow seccion-seleccionada white--text">
            <span class="menu-title">{{menuSeleccionado.title}}</span>
          </div>
        </li>
        <template v-for="(item, key) in menuSeleccionado.items">
          <li
            class="nav-item"
            v-if="!item['puedo'] || $puedo(item['puedo'][0])"
            :key="key"
          >
            <router-link
              :to="item.path"
              class="nav-link no-arrow"
              active-class="white primary--text"
            >
              <span>{{(item.title)}}</span>
            </router-link>

          </li>
        </template>
      </template>

    </ul>
    <div class="ham-menu-sm d-none">
      <v-btn
        flat
        icon
        class="my-1 mx-3"
        @click="toggleHorizontalLayoutSidebar"
      >
        <v-icon class="white--text">menu</v-icon>
      </v-btn>
    </div>
    <div>
      <div class="search-form">
        <v-text-field
          flat
          solo
          prepend-icon="search"
          :placeholder="'Buscar'"
          class="search-bar"
        ></v-text-field>
        <div class="mobile-search d-none">
          <v-btn
            flat
            small
            icon
            class="mobile-search-btn my-1 mx-3"
            @click="toggleSearchForm"
          >
            <v-icon class="white--text font-md">search</v-icon>
          </v-btn>
        </div>
      </div>
      <mobile-search-form></mobile-search-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppMenuItem from './AppMenuItem'
import MobileSearchForm from '../Header/MobileSearchForm'

export default {
  data () {
    return {
      categories: {
        General: 'zmdi zmdi-view-dashboard',
        'message.modules': 'zmdi zmdi-widgets',
        'message.components': 'zmdi zmdi-view-carousel',
        'message.applications': 'zmdi zmdi-assignment-check',
        'message.features': 'zmdi zmdi-wrench',
        'message.extensions': 'zmdi zmdi-file'
      },
      categoriaSeleccionada: null

    }
  },
  components: {
    AppMenuItem,
    MobileSearchForm
  },
  computed: {
    ...mapGetters(['menus', 'menuSeleccionado'])
  },
  methods: {
    toggleHorizontalLayoutSidebar () {
      this.$store.dispatch('toggleHorizontalLayoutSidebar', true)
    },
    toggleSearchForm () {
      this.$store.dispatch('toggleSearchForm')
    }
  },
  mounted () {
    const mainMenu = document.getElementsByClassName('nav-item')
    for (let i = 0; i < mainMenu.length; i++) {
      mainMenu[i].onclick = function () {
        for (let j = 0; j < mainMenu.length; j++) {
          if (mainMenu[j].classList.contains('nav-item-active')) {
            mainMenu[j].classList.remove('nav-item-active')
          }
        }
        this.classList.toggle('nav-item-active')
      }
    }
  }
}
</script>
<style scoped>
.seccion-seleccionada {
  padding: 0.9375rem 1rem 0.9375rem 1rem;
  font-size: 0.875rem;
}
.nav-link {
  color: white !important;
}
.router-link-exact-active,
.nav-item-active a {
  color: #000000 !important;
}

.nav-link:hover {
  color: gray !important;
}
</style>
